import { FC, ReactNode } from 'react';
import { cva } from 'class-variance-authority';
import { Accordion as RadixAccordion } from 'radix-ui';
import { twMerge } from 'tailwind-merge';
import { ChevronUp } from '../svgs';

const AccordionCVA = cva([''], {
  variants: {},
});

type AccordionItem = {
  trigger: ReactNode;
  content: ReactNode;
  value: string;
  onToggle?: (expanded: boolean) => void;
};
export interface AccordionProps extends RadixAccordion.AccordionSingleProps {
  className?: string;

  accordions: AccordionItem[];
}

export const Accordion: FC<AccordionProps> = ({ className, accordions, ...otherProps }) => {
  return (
    <RadixAccordion.Root
      // ? there is no multiple user case
      className={twMerge(
        'w-[380px] rounded-md shadow-[0_4px_40px_0_var(--accordion-shadow)]',
        className
      )}
      {...otherProps}
    >
      {accordions.map(accordion => (
        <RadixAccordion.AccordionItem key={accordion.value} value={accordion.value}>
          <RadixAccordion.Header className="flex">
            <RadixAccordion.AccordionTrigger
              className="group flex h-[45px] flex-1 cursor-default items-center justify-between px-[--padding-md] py-[--padding-xs] leading-none shadow-[0_1px_0_0_var(--accordion-divider)] outline-none"
              onClick={event => accordion.onToggle?.(event.currentTarget.dataset.state !== 'open')}
            >
              {accordion.trigger}
              <ChevronUp
                className="text-[--color-neutral-900] transition-transform duration-300 ease-[cubic-bezier(0.87,_0,_0.13,_1)] group-data-[state=open]:rotate-0 rotate-180"
                aria-hidden
              />
            </RadixAccordion.AccordionTrigger>
          </RadixAccordion.Header>
          <RadixAccordion.AccordionContent className="overflow-hidden p-[--padding-md] data-[state=closed]:animate-slideUp data-[state=open]:animate-slideDown">
            {accordion.content}
          </RadixAccordion.AccordionContent>
        </RadixAccordion.AccordionItem>
      ))}
    </RadixAccordion.Root>
  );
};
